import { CButton, CRow, CCol, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormSelect, CFormInput, CFormText, CFormCheck } from '@coreui/react'
import React from 'react'
import { useState, useRef } from 'react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveDiagnosisData from '../../services/general/saveDiagnosisData.api'
import DeleteDiagnosis from '../../services/general/deleteDiagnosis.api'
import { Form } from '@formio/react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import Fn_FacilityDetailsCRUD from '../../services/general/facilityDetailsCRUD.api'
import FacilityTypeFn from '../../services/general/modifyFacilityType.api'
import FacilityForm from './FacilityForm'
import axios from 'axios'
import { useEffect } from 'react'

import UploadFacility from './UploadFacility'
import Pageloader from '../../components/shared/Pageloader'
import { getFacilityParentCompany, parseFacilityOtherDetails } from '../../utils/facilityParentCompany'

const Facility = () => {
  const formData = useRef({})
  const [schema, setSchema] = useState({ components: [] })
  const [formAnswer, setFormAnswer] = useState({ components: [] })
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)

  const update = useRef('EDIT')
  const [visible, setVisible] = useState(false)
  const facilityID = useRef('')
  const facilitiesToAdd = useRef()
  const [options, setOptions] = useState([])
  const [modalVisible, setModalVisible] = useState(false)

  const submitFn = async () => {
    setModalVisible(false)

    facilityID.current = ''
    update.current = ''

    try {
      if (facilitiesToAdd.current.length > 0) {
        let newFacility = facilitiesToAdd.current.pop()
        update.current = 'INSERT'
        rowData.current = {}
        setNewFacilityName(newFacility)
        rowData.current.Name = newFacility
        rowData.current.Status = ''
        rowData.current.Sister = true
        setModalVisible(true)
      } else {
        let a = await getData()
        setModalVisible(false)
      }
    } catch (e) {
      let a = await getData()
      setModalVisible(false)
    }
  }
  const getFacilityType = async () => {
    let a = await FacilityTypeFn('SELECT', '', '')
    let data = a.d
    data = JSON.parse(data)
    setOptions(data.Data.map((obj) => obj.Name))
  }

  const updateFacility = async (type, e) => {
    facilityID.current = e.ID
    rowData.current = e
    update.current = type
    if (type == 'DELETE') {
      setDeleteVisibleId({ name: e.Name, id: e.ID, type: e.Type })
      await getData()
    } else if (type == 'EDIT') {
      setSelectedValue(e.Type)
      setInputValue(e.Name)
      setNewFacilityName('')
      setParentCompany('')
      setModalVisible((e) => !e)
    } else {
      facilityName.current = e.Name
      if (e.Type == '' || e.Type == null) {
        alert('Please set type of Facility')
      } else {
        fetchFacilityData(e.Type, e.Name, e.ID)
      }
    }
  }

  const handleonClick = (e) => {
    update.current = 'INSERT'
    rowData.current = {}
    setNewFacilityName('')
    setParentCompany('')
    setModalVisible((e) => !e)
  }

  const saveFacility = async () => {
    // SaveDiagnosisData()
    let name = inputValue
    let type = selectedValue
    let a = await FacilityCRUD(update.current, { name: name, id: facilityID?.current, type: type })
    await getData()
    setModalVisible(false)
  }

  const fetchFacilityData = async (type, name, id) => {
    let c = await Fn_FacilityDetailsCRUD('', '', type, 'GET', '')

    if (c.d == '') {
      setSchema({ components: [] })
    } else {
      let temp = JSON.parse(c.d)

      setSchema(temp)
    }

    let a = await Fn_FacilityDetailsCRUD('Details', '', name, 'GET', id)

    if (a.d == '') {
      alert('No Details Found')
      // setSchema({components: []})
    } else {
      let temp = JSON.parse(a.d)
      setFormAnswer(temp)
    }
    setVisible(true)
  }

  const [facilityTypes, setFacilityTypes] = useState([])
  const getData = async () => {
    setIsPageLoading(true)
    try {
      let a = await FacilityCRUD('SELECT', {})
      await getFacilityType()
      let data = JSON.parse(a.d)

      // Sort facilities alphabetically by Name
      if (data.Data && Array.isArray(data.Data)) {
        data.Data.sort((a, b) => 
          (a.Name || '')
            .trim()
            .toLowerCase()
            .localeCompare((b.Name || '').trim().toLowerCase())
        )
      }

      setDiagnosisData(JSON.stringify(data))

      let temp3 = FacilityTypeFn('SELECT')
      temp3.then((res) => {
        try {
          let types = JSON.parse(res.d)

          let temp = types.Data.map((obj, i) => {
            return { value: obj['Name'], label: obj['Name'] }
          })
          setFacilityTypes(temp)
        } catch (e) {}
      })
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }
  const [showUploadFacility, setShowUploadFacility] = useState(false)
  const buttonList = [
    { Name: 'Edit', FunctionName: updateFacility },
    { Name: 'Delete', FunctionName: updateFacility },
    { Name: 'Details', FunctionName: updateFacility },
  ]
  const [diagnosisData, setDiagnosisData] = useState('')
  const [selectedValue, setSelectedValue] = useState('')

  const [inputValue, setInputValue] = useState('')

  const facilityName = useRef('')
  const rowData = useRef({})
  const [newFacilityName, setNewFacilityName] = useState('')
  const [parentCompany, setParentCompany] = useState('')

  useEffect(() => {
    let a = getData()
  }, [])
  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value)
  }

  const saveFormData = async (state) => {
    let facilitiesData = JSON.parse(diagnosisData).Data
    await Fn_FacilityDetailsCRUD('Details', JSON.stringify(formData.current), facilityName.current, 'INSERT', facilityID.current)
    let status = ''
    if (state == 'Verified') {
      status = 'Completed'
    } else {
      status = 'In Progress'
    }
    await FacilityCRUD('EDIT', { id: facilityID.current, name: facilityName.current, status })
    alert('Form Saved')
    setVisible(false)
    setParentCompany(facilityName.current)
    let d = formData.current
    let facilities = d.data[Object.keys(d.data).find((obj) => obj.includes('sister'))]
    if (facilities.length > 0) {
      const combinedFacilities = [] // Create a copy of the allFacilities array
      facilities.forEach((name) => {
        const facilityExists = facilitiesData.some((facility) => facility.Name.toLowerCase() === name.toLowerCase())

        if (!facilityExists) {
          // Add a new facility object with a unique ID and the given name
          // Set the type property as needed, or use a default value
          combinedFacilities.push(name)
        }
      })

      facilitiesToAdd.current = combinedFacilities
      let newFacility = facilitiesToAdd.current.pop()
      update.current = 'INSERT'
      rowData.current = {}
      rowData.current.Name = newFacility
      rowData.current.Status = ''
      rowData.current.Sister = true
      setModalVisible(true)
    } else {
      await getData()
    }
  }
  const getCoordinates = async (addr) => {
    const geocoder = new window.google.maps.Geocoder()
    let latlong = {}
    try {
      await geocoder.geocode({ address: addr }, (results, status) => {
        if (status === 'OK') {
          const latLng = results[0].geometry.location
          let allAddress = results[0]['address_components']
          let addressDetails = {}

          allAddress.map((obj) => {
            let l = obj['types'][0]
            addressDetails[l] = obj['long_name']
          })

          latlong = { lat: latLng.lat(), lng: latLng.lng(), addressDetails, city: addressDetails['locality'] }
        } else {
          latlong = { lat: null, lng: null, addressDetails: null, city: null }
        }
      })
    } catch (e) {
      console.log(e)
      let a = ''
    }

    return latlong
  }
  const handleUpload = async (e) => {
    console.log(e)
    let validData = e.validData

    let listOfFacilities = JSON.parse(diagnosisData)['Data']

    for (let i = 0; i < validData?.length; i++) {
      let obj = validData[i]

      let found = listOfFacilities.find((o) => {
        if (o.Name == obj.name) {
          return obj
        }
      })
      if (found != undefined) {
        continue
      }
      let latlng = await getCoordinates(obj['address'])
      let lat = latlng.lat
      let lng = latlng.lng
      let addressDetails = latlng.addressDetails
      let city = latlng.city
      let otherDetails = {}
      await FacilityCRUD('INSERT', { id: null, name: obj['name'], type: obj['type'], address: obj['address'], lat, lng, status: 'Pending', addressDetails, city: city, otherDetails })
    }
  }
  const handleUploadFacility = (e) => {
    setShowUploadFacility((e) => !e)
  }

  const handleDelete = async (e) => {
    await FacilityCRUD('DELETE', deleteVisibleId)
    await getData()
    setDeleteVisibleId(null)
  }

  const currentFacilityOtherDetails = parseFacilityOtherDetails(rowData.current?.OtherDetails)

  return (
    <>
      <div className="position-relative patient-theme-page facility-theme">
        <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
        <CCard className="m-2 facility-theme__toolbar">
          <CCardBody className="facility-theme__toolbar-body">
            <CRow>
              <CCol sm={4}>
                <CButton className="m-2 ui-action-btn ui-action-btn--primary" onClick={handleonClick}>
                  + Add Facility
                </CButton>
                {/* <CButton className="m-2" variant="outline" color="success" onClick={handleUploadFacility}>
                Upload Facility
              </CButton>
   {showUploadFacility && <UploadFacility typeOptions={facilityTypes} HandleUploadFn={handleUpload}></UploadFacility>} */}
              </CCol>
              <CCol></CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CustomAgGrid
          className="facility-theme__grid"
          rowClickedFn={updateFacility}
          callFrom="Facility"
          options={diagnosisData ? JSON.stringify({ ...JSON.parse(diagnosisData), Data: JSON.parse(diagnosisData)?.Data?.map(({ OtherDetails, ...rest }) => rest) }) : diagnosisData}
          btnList={buttonList}
        ></CustomAgGrid>

        <CModal className="patient-theme-modal facility-theme__modal" size="lg" visible={modalVisible} backdrop={'static'} keyboard={false} onClose={() => setModalVisible(false)}>
          <CModalHeader onClose={() => setModalVisible(false)}>
            <CModalTitle>Add Facility</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <FacilityForm
              initialType={rowData.current.Type}
              initialAddress={rowData.current.Address}
              Mode={update.current}
              typeOptions={options}
              facilityID={rowData.current.ID}
              ParentCompany={parentCompany}
              Sister={rowData.current?.Sister}
              initialCity={rowData.current?.City}
              initialState={rowData.current?.State}
              initialCounty={rowData.current.County}
              initialDays={rowData.current.Days}
              initialName={newFacilityName == '' ? rowData.current.Name : newFacilityName}
              initialParentCompany={getFacilityParentCompany(rowData.current?.OtherDetails)}
              initialOtherDetails={currentFacilityOtherDetails}
              Status={rowData.current?.Status}
              onSubmit={submitFn}
              isPecosAddedProps={currentFacilityOtherDetails?.isPecosAdded || false}
              pecosDateProps={currentFacilityOtherDetails?.PecosDate || ''}
            ></FacilityForm>
          </CModalBody>
          {/* <CModalFooter>
    <CButton color="secondary" onClick={() => setModalVisible(false)}>Close</CButton>
    <CButton color="primary" onClick={()=>saveFacility()}>Save changes</CButton>
  </CModalFooter> */}
        </CModal>

        <CModal className="patient-theme-modal facility-theme__modal" size="lg" backdrop={'static'} keyboard={false} visible={visible} onClose={() => setVisible(false)}>
          <CModalHeader onClose={() => setVisible(false)}>
            <CModalTitle>Facility Details</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div style={{ maxHeight: '65vh', overflowY: 'auto', padding: '0 4px' }}>
              <Form
                form={schema}
                submission={formAnswer}
                onChange={(e) => {
                  formData.current = { data: e.data }
                }}
              />
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setVisible(false)}>
              Close
            </CButton>
            <CButton
              className="ui-action-btn ui-action-btn--primary"
              onClick={(e) => {
                saveFormData('Save')
              }}
            >
              Save Changes
            </CButton>
            <CButton
              className="ui-action-btn ui-action-btn--primary"
              onClick={(e) => {
                saveFormData('Verified')
              }}
            >
              Verified
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal className="patient-theme-modal facility-theme__modal" visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              color="secondary"
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
            <CButton onClick={handleDelete} color="danger" className="ui-action-btn ui-action-btn--delete" style={{ color: '#fff' }}>
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
        <Pageloader isLoading={isPageLoading} />
        </div>
      </div>
    </>
  )
}

const AddButton = () => {
  return (
    <>
      <CButton style={{ marginLeft: '10px' }} variant="outline" color="success">
        ADD +
      </CButton>
    </>
  )
}

export default Facility



// import React, { useEffect, useState } from 'react'
// import { CCard, CCardBody, CButton } from '@coreui/react'
// import CustomAgGrid from './../../components/shared/CustomAgGrid'
// import FacilityCRUD from '../../services/general/getFacilityData.api'

// const Facility = ({ type  }) => {
//   const [facilityData, setFacilityData] = useState('')
//   const [loading, setLoading] = useState(false)




//   const getFacilities = async () => {
//   setLoading(true)

//   try {
//     const res = await FacilityCRUD('SELECT', {})

//     const parsed = JSON.parse(res.d)
//     let data = parsed?.Data || []

//     // 🔥 filter by type prop
//     if (type) {
//       data = data.filter(item => item.Type === type)
//     }

//     setFacilityData(data)
//   } catch (err) {
//     console.error(err)
//   } finally {
//     setLoading(false)
//   }
// }
//   useEffect(() => {
//     getFacilities()
//   }, [])

//   // 🔥 Row click handler (optional)
//   const handleRowClick = (type, row) => {
//     console.log('Clicked:', type, row)
//   }

//   const buttonList = [
//     { Name: 'Edit', FunctionName: handleRowClick },
//     { Name: 'Delete', FunctionName: handleRowClick },
//         { Name: 'Patients', FunctionName: handleRowClick },
//     { Name: 'Delete', FunctionName: handleRowClick },
//   ]

//   return (
//     <div className="p-3">
//       <CCard>
//         <CCardBody>
//           <div className="d-flex justify-content-between mb-3">
//             <h5>Facility List</h5>
//             <CButton onClick={getFacilities} color="primary" variant="outline">
//               Refresh
//             </CButton>
//           </div>

//           {/* 🔥 Facility List Grid */}
//           <CustomAgGrid
//             options={facilityData}
//             btnList={buttonList}
//             rowClickedFn={handleRowClick}
//             callFrom="Facility"
//           />
//         </CCardBody>
//       </CCard>

//       {loading && <p>Loading...</p>}
//     </div>
//   )
// }

// export default Facility



// import React, { useEffect, useState } from 'react'
// import {
//   CCard,
//   CCardBody,
//   CButton,
//   CAccordion,
//   CAccordionItem,
//   CAccordionHeader,
//   CAccordionBody,
//   CSpinner,
//   CBadge
// } from '@coreui/react'

// import FacilityCRUD from '../../services/general/getFacilityData.api'
// import Patient from './Patient'
// import SavePatients from '../../../src/services/general/savePatientinformation.api'


// const Facility = ({ type }) => {
//   const [facilityData, setFacilityData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [patientData, setPatientData] = useState([])

//   const getFacilities = async () => {
//     setLoading(true)

//     try {
//       const res = await FacilityCRUD('SELECT', {})

//       const parsed = JSON.parse(res.d)
//       let data = parsed?.Data || []


//       console.log("facility data", parsed )

//       // 🔥 filter by type (SNF / ALF)
//       if (type) {
//         data = data.filter(item => item.Type === type)
//       }

//       setFacilityData(data)
//     } catch (err) {
//       console.error(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const getPatientsByFacility = (facilityName, patients) => {
//   if (!patients || !facilityName) return []

//   return patients.filter((p) =>
//     (p.FacilityName || '').trim().toLowerCase() ===
//     facilityName.trim().toLowerCase()
//   )
// }

//   useEffect(() => {
//     getFacilities()
//     patientDataFn()
    
//   }, [type])

//   const patientDataFn = async () => {
//   setIsPageLoading(true)
//   try {
//     let patientData = await SavePatients('GetAll', '', '', '')
//     setPatientData(JSON.parse(patientData.d).Data)
//     let count = JSON.parse(patientData.d).Data.length
//     setPatientCount(count)
//   } catch (error) {
//   } finally {
//     setIsPageLoading(false)
//   }
// }
//   useEffect(() => {
//     const fetchPatients = async () => {
//       try {
//         const res = await SavePatients('GetAll', '', '', '')
//         console.log('API Response:', JSON.stringify(res))

//         const parsed = JSON.parse(res.d)
//         console.log('Parsed Data:', parsed)
//       } catch (error) {
//         console.error('Error fetching patients:', error)
//       }
//     }

//     fetchPatients()
//   }, [])



//   return (
//     <div className="p-3">
//       <CCard>
//         <CCardBody>
//           <div className="d-flex justify-content-between mb-3">
//             <h5>
//               Facility List {type ? `(${type})` : ''}
//             </h5>

//             <CButton onClick={getFacilities} color="primary" variant="outline">
//               Refresh
//             </CButton>
//           </div>

//           {loading && (
//             <div className="text-center mb-3">
//               <CSpinner />
//             </div>
//           )}

//           {/* <Patient></Patient> */}

//           {/* 🔥 Accordion List */}
//           <CAccordion alwaysOpen>
//             {facilityData.map((item, index) => (
//         <CAccordionItem key={item.ID || index} itemKey={index}>
//   <CAccordionHeader>
//     <div className="d-flex justify-content-between align-items-center w-100 pe-2">

//       {/* Left: Name + subtle subtitle */}
//       <div className="d-flex flex-column">
//         <strong className="fs-6">{item.Name}</strong>
//         <small className="text-muted">
//           {item.City} • {item.State}
//         </small>
//       </div>

//       {/* Right: Type Badge + Status */}
//       <div className="d-flex align-items-center gap-2">

//         <CBadge className="bg-transparent text-primary border border-primary rounded-pill px-3 py-1">
//           {item.Type}
//         </CBadge>

//         {/* <CBadge
//           className={`rounded-pill px-3 py-1 ${
//             item.Status === 'Active'
//               ? 'bg-success text-black'
//               : 'bg-secondary text-black'
//           }`}
//         >
//           {item.Status}
//         </CBadge> */}

//       </div>

//     </div>
//   </CAccordionHeader>

//   <CAccordionBody>
//     <div className="p-2">

//       {/* Grid layout */}
//       <div className="row g-3">

//         <div className="col-md-6">
//           <div className="text-muted small">City</div>
//           <div className="fw-semibold">{item.City}</div>
//         </div>

//         <div className="col-md-6">
//           <div className="text-muted small">State</div>
//           <div className="fw-semibold">{item.State}</div>
//         </div>

//         <div className="col-md-6">
//           <div className="text-muted small">County</div>
//           <div className="fw-semibold">{item.County}</div>
//         </div>

//         <div className="col-md-6">
//           <div className="text-muted small">Days</div>
//           <div className="fw-semibold">{item.Days}</div>
//         </div>

//         <div className="col-12">
//           <div className="text-muted small">Address</div>
//           <div className="fw-semibold">{item.Address}</div>
//         </div>

//       </div>

//        <div className="patient-list mt-3">
//       <strong className="mb-2 d-block">Patients</strong>


//       <CAccordionBody>
//   <div className="p-2">

//     <div className="mb-2 text-muted small">
//       Patients: {filteredPatients.length}
//     </div>

//     <div className="list-group">
//       {filteredPatients.map((patient) => (
//         <div
//           key={patient.PatientID}
//           className="list-group-item d-flex justify-content-between align-items-center"
//           style={{ borderRadius: '10px', marginBottom: '6px' }}
//         >
//           <div>
//             <div className="fw-semibold">
//               {patient.FirstName} {patient.LastName}
//             </div>
//             <div className="text-muted small">
//               Room: {patient.Room}
//             </div>
//           </div>

//           <span className="badge bg-primary">
//             {patient.Status}
//           </span>
//         </div>
//       ))}
//     </div>

//   </div>
// </CAccordionBody>

//       {patientData
//         .filter(patient => patient.FacilityID === item.ID) // filter by facility
//         .map((patient, idx) => (
//           <div key={idx} className="p-2 mb-2 border rounded d-flex justify-content-between align-items-center">
//             <div>
//               <div className="fw-semibold">{patient.Name}</div>
//               <small className="text-muted">{patient.Age} yrs • {patient.Gender}</small>
//             </div>
//             <CButton size="sm" color="primary" variant="outline">
//               View
//             </CButton>
//           </div>
//         ))
//       }

//       {patientData.filter(p => p.FacilityID === item.ID).length === 0 && (
//         <div className="text-muted small">No patients found</div>
//       )}


//     </div>


//     </div>
//   </CAccordionBody>



// </CAccordionItem>
//             ))}
//           </CAccordion>

//         </CCardBody>
//       </CCard>
//     </div>
//   )
// }

// export default Facility


// import React, { useEffect, useState } from 'react'
// import {
//   CCard, CCardBody, CButton, CAccordion, CAccordionItem,
//   CAccordionHeader, CAccordionBody, CSpinner, CBadge
// } from '@coreui/react'

// import FacilityCRUD from '../../services/general/getFacilityData.api'
// import SavePatients from '../../../src/services/general/savePatientinformation.api'

// const Facility = ({ type }) => {
//   const [facilityData, setFacilityData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [patientData, setPatientData] = useState([])

//   const getFacilities = async () => {
//     setLoading(true)
//     try {
//       const res = await FacilityCRUD('SELECT', {})
//       const parsed = JSON.parse(res.d)
//       let data = parsed?.Data || []
//       if (type) {
//         data = data.filter(item => item.Type === type)
//       }
//       setFacilityData(data)
//     } catch (err) {
//       console.error(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const patientDataFn = async () => {
//     try {
//       const res = await SavePatients('GetAll', '', '', '')
//       const parsed = JSON.parse(res.d)
//       setPatientData(parsed?.Data || [])
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   // ✅ Filter patients by facility name — called inside the map
//   const getPatientsByFacility = (facilityName) => {
//     if (!facilityName) return []
//     return patientData.filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )
//   }

//     const getAppointmentData = async () => {
//       setIsPageLoading(true)
//       try {
//         const structureData = await getAllAppointments('GET')
//         let filterPatient = structureData.filter((item) => item.patientID === viewPatientDetail.PatientID)
  
//         let flatAppointments = filterPatient.flatMap((p) => p.appointmentDetails)
  
//         setAppointments(flatAppointments || [])
//       } catch (error) {
//         console.log('Error in getAppointmentData', error)
//       } finally {
//         setIsPageLoading(false)
//       }
//     }
  

//   useEffect(() => {
//     getFacilities()
//     patientDataFn()
//   }, [type])

//   return (
//     <div className="p-3">
//       <CCard>
//         <CCardBody>
//           <div className="d-flex justify-content-between mb-3">
//             <h5>Facility List {type ? `(${type})` : ''}</h5>
//             <CButton onClick={getFacilities} color="primary" variant="outline">
//               Refresh
//             </CButton>
//           </div>

//           {loading && (
//             <div className="text-center mb-3">
//               <CSpinner />
//             </div>
//           )}

//           <CAccordion alwaysOpen>
//             {facilityData.map((item, index) => {
//               // ✅ Computed per facility inside the map
//               const filteredPatients = getPatientsByFacility(item.Name)

//               return (
//                 <CAccordionItem key={item.ID || index} itemKey={index}>
//                   <CAccordionHeader>
//                     <div className="d-flex justify-content-between align-items-center w-100 pe-2">
//                       <div className="d-flex flex-column">
//                         <strong className="fs-6">{item.Name}</strong>
//                         <small className="text-muted">
//                           {item.City} • {item.State}
//                         </small>
//                       </div>
//                       <div className="d-flex align-items-center gap-2">
//                         <CBadge className="bg-transparent text-primary border border-primary rounded-pill px-3 py-1">
//                           {item.Type}
//                         </CBadge>
//                       </div>
//                     </div>
//                   </CAccordionHeader>

//                   <CAccordionBody>
//                     <div className="p-2">

//                       {/* Facility Details
//                       <div className="row g-3 mb-3">
//                         <div className="col-md-6">
//                           <div className="text-muted small">City</div>
//                           <div className="fw-semibold">{item.City}</div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="text-muted small">State</div>
//                           <div className="fw-semibold">{item.State}</div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="text-muted small">County</div>
//                           <div className="fw-semibold">{item.County}</div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="text-muted small">Days</div>
//                           <div className="fw-semibold">{item.Days}</div>
//                         </div>
//                         <div className="col-12">
//                           <div className="text-muted small">Address</div>
//                           <div className="fw-semibold">{item.Address}</div>
//                         </div>
//                       </div> */}

//                       {/* ✅ Patient List */}
//                       <strong className="mb-2 d-block">
//                         Patients ({filteredPatients.length})
//                       </strong>

//                       {filteredPatients.length === 0 ? (
//                         <div className="text-muted small">No patients found</div>
//                       ) : (
//                         <div className="list-group">
//                           {filteredPatients.map((patient) => (
//                             <div
//                               key={patient.PatientID}
//                               className="list-group-item d-flex justify-content-between align-items-center"
//                               style={{ borderRadius: '10px', marginBottom: '6px' }}
//                             >
//                               <div>
//                                 <div className="fw-semibold">
//                                   {patient.FirstName} {patient.LastName}
//                                 </div>
//                                 <div className="text-muted small">
//                                   Room: {patient.Room} • Age: {patient.Age} • {patient.Gender}
//                                 </div>
//                                 {patient.Diagnosis && (
//                                   <div className="text-muted small">
//                                     Dx: {patient.Diagnosis}
//                                   </div>
//                                 )}
//                               </div>
//                               <CBadge
//                                 color={patient.Status === 'Follow Up' ? 'warning' : 'primary'}
//                                 className="rounded-pill px-2"
//                               >
//                                 {patient.Status}
//                               </CBadge>
//                             </div>
//                           ))}
//                         </div>
//                       )}

//                     </div>
//                   </CAccordionBody>
//                 </CAccordionItem>
//               )
//             })}
//           </CAccordion>

//         </CCardBody>
//       </CCard>
//     </div>
//   )
// }

// export default Facility


// import React, { useEffect, useState } from 'react'
// import {
//   CCard, CCardBody, CButton, CAccordion, CAccordionItem,
//   CAccordionHeader, CAccordionBody, CSpinner, CBadge,
//   CTableDataCell,
//   CTableRow,
//   CTableBody,
//   CTableHeaderCell
// } from '@coreui/react'
// import { CalendarDays } from 'lucide-react'

// import FacilityCRUD from '../../services/general/getFacilityData.api'
// import SavePatients from '../../../src/services/general/savePatientinformation.api'
// import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
// import { getAllAppointments } from '../../../src/components/shared/appointmentFilterData'



// const DEFAULT_FILTERS = {
//   facility: '',
//   patientStatus: '',
//   noteStatus: '',
//   appointmentStatus: '',
//   dobFrom: '',
//   dobTo: '',
// }




// const Facility = ({ type }) => {
//   const [facilityData, setFacilityData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [patientData, setPatientData] = useState([])
//   // ✅ Store notes keyed by PatientID: { 1234: [...notes] }
//   const [patientNotes, setPatientNotes] = useState({})
//   // ✅ Track which facility accordions have been opened (for lazy load)
//   const [openedFacilities, setOpenedFacilities] = useState(new Set())


//     const [appointments, setAppointments] = useState([])
//   const [viewPatientDetail, setViewPatientDetail] = useState(null);


//    const [showFilters, setShowFilters] = useState(false)
//   const [filters, setFilters]         = useState(DEFAULT_FILTERS)
//   const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS)



//   const getPatientAppointment = (patientID) => {
//   return appointments?.filter(
//     (a) => a?.data?.PatientID === patientID
//   ) || []
// }







  







//   useEffect(()=>{
//     getAppointmentData()
// getLatestNote()
//   }, [])


//   useEffect(() => {
//   console.log("📊 Current appointments state:", appointments);
// }, [appointments]);


//   const getFacilities = async () => {
//     setLoading(true)
//     try {
//       const res = await FacilityCRUD('SELECT', {})
//       const parsed = JSON.parse(res.d)
//       let data = parsed?.Data || []


//       // console.log(data, "facilityData");

//          data = data.sort((a, b) =>
//       (a.Name || "").localeCompare(b.Name || "")
//     );

//       if (type) {
//         data = data.filter((item) => item.Type === type)
//       }
//       setFacilityData(data)
//     } catch (err) {
//       console.error(err)
//     } finally {
//       setLoading(false)
//     }
//   }



//     //   const getAppointmentData = async () => {
    
//     //   try {
//     //     const structureData = await getAllAppointments('GET')
//     //     let filterPatient = structureData.filter((item) => item.patientID === viewPatientDetail.PatientID)
  
//     //     let flatAppointments = filterPatient.flatMap((p) => p.appointmentDetails)
  
//     //     setAppointments(flatAppointments || [])


//     //     console.log(appointments, "getAppointmentData")
//     //   } catch (error) {
//     //     console.log('Error in getAppointmentData', error)
//     //   } 
//     // }

// // const getAppointmentData = async () => {
// //   try {
// //     console.log("🚀 Fetching appointments...");

// //     const structureData = await getAllAppointments('GET');

// //     console.log("📦 Raw structureData:", structureData);

// //     if (!viewPatientDetail?.PatientID) {
// //       console.log("⚠️ No viewPatientDetail selected");
// //       return;
// //     }

// //     console.log("👤 Filtering for PatientID:", viewPatientDetail.PatientID);

// //     const filterPatient = structureData.filter(
// //       (item) => item.patientID === viewPatientDetail.PatientID
// //     );

// //     console.log("🔍 Filtered patient data:", filterPatient);

// //     const flatAppointments = filterPatient.flatMap(
// //       (p) => p.appointmentDetails || []
// //     );

// //     console.log("📅 Final flat appointments:", flatAppointments);

// //     setAppointments(flatAppointments || []);

// //   } catch (error) {
// //     console.log("❌ Error in getAppointmentData", error);
// //   }
// // };

// // const getAppointmentData = async () => {
// //   try {
// //     console.log("🚀 Fetching appointments...");

// //     const structureData = await getAllAppointments('GET');

// //     if (!viewPatientDetail?.PatientID) {
// //       console.log("⚠️ No viewPatientDetail selected");
// //       return;
// //     }

// //     const filterPatient = structureData.filter(
// //       (item) => item.PatientID === viewPatientDetail.PatientID
// //     );

// //     const flatAppointments = filterPatient.flatMap(
// //       (p) => p.appointmentDetails || []
// //     );

// //     console.log("📅 Final flat appointments:", flatAppointments);

// //     // ✅ Extract VisitReason
// //     const visitReasons = flatAppointments
// //       .map(item => item?.data?.VisitReason)
// //       .filter(Boolean);

// //     console.log("Visit Reasons:", visitReasons);

// //     setAppointments(flatAppointments || []);

// //   } catch (error) {
// //     console.log("❌ Error in getAppointmentData", error);
// //   }
// // };



// const getAppointmentData = async () => {
//   try {
//     const structureData = await getAllAppointments('GET');

//     const flatAppointments = structureData.flatMap(
//       (p) => p?.appointmentDetails || []
//     );

//     console.log("📦 FLAT APPOINTMENTS:", flatAppointments);

//     setAppointments(flatAppointments);

//   } catch (error) {
//     console.log("❌ Error in getAppointmentData", error);
//   }
// };




//   const patientDataFn = async () => {
//     try {
//       const res = await SavePatients('GetAll', '', '', '')
//       const parsed = JSON.parse(res.d)
//       setPatientData(parsed?.Data || [])
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   const getPatientsByFacility = (facilityName) => {
//     if (!facilityName) return []
//     return patientData.filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )
//   }

//   // ✅ Accept patientData as param instead of relying on closure
// const fetchNotesForFacility = async (facilityName, currentPatientData) => {
//   if (openedFacilities.has(facilityName)) return
//   setOpenedFacilities((prev) => new Set([...prev, facilityName]))

//   // ✅ Use passed-in data, not stale state
//   const patients = (currentPatientData || []).filter(
//     (p) =>
//       (p.FacilityName || '').trim().toLowerCase() ===
//       facilityName.trim().toLowerCase()
//   )



//   console.log('patients to fetch notes for:', patients.length, patients)

//   if (patients.length === 0) return

//   const notePromises = patients.map(async (patient) => {
//     try {
//       let data = await PatientNoteDataCRUD('GET', patient.PatientID)
//       console.log('raw note response for', patient.PatientID, data)

//       data = JSON.parse(data.d)?.Data || []
//       console.log('parsed notes for', patient.PatientID, data)
//       console.log('parsed notes for status', patient.PatientID, data.status)
//       data.forEach(note => {
//   console.log(
//     'patient:',
//     patient.PatientID,
//     'noteId:',
//     note.id,
//     'status:',
//     note.status
//   );
// });
      

//       data = data.map((item) => ({
//         ...item,
//         data: item?.data ? JSON.parse(item?.data) : {},
//       }))

//       return { patientID: patient.PatientID, notes: data }
//     } catch (err) {
//       console.error('Note fetch error for patient', patient.PatientID, err)
//       return { patientID: patient.PatientID, notes: [] }
//     }
//   })

//   const results = await Promise.all(notePromises)
//   console.log('all note results:', results)

//   setPatientNotes((prev) => {
//     const updated = { ...prev }
//     results.forEach(({ patientID, notes }) => {
//       updated[patientID] = notes
//     })
//     return updated
//   })
// }

//   // ✅ Get the latest note for a patient
// //   const getLatestNote = (patientID) => {
// //     const notes = patientNotes[patientID]
// //   console.log("--->",notes);
// //     if (!notes || notes.length === 0) {
// // return null
// //     }
// //     // Sort by date descending and return the most recent
// //   }

// //   const getLatestNote = (patientID) => {
// //   const notes = patientNotes[String(patientID)];

// //   console.log("patientID:", patientID);
// // console.log("patientNotes:", patientNotes);
// // console.log("notes for ID:", patientNotes?.[patientID]);
// // console.log("Available keys:", Object.keys(patientNotes));
// // console.log("Looking for:", patientID);

// //   console.log(notes);

// //   if (!notes || notes.length === 0) {
// //     return null;
// //   }

// //   const latest = [...notes].sort(
// //     (a, b) => new Date(b.date) - new Date(a.date)
// //   )[0];

// //   return latest;
// // };

// const getLatestNote = (patientID) => {
//   const notes = patientNotes?.[String(patientID)];

//   console.log("patientID:", patientID);
//   console.log("notes:", notes);

//   if (!Array.isArray(notes) || notes.length === 0) {
//     return null;
//   }

//   return [...notes].sort(
//     (a, b) => new Date(b.date) - new Date(a.date)
//   )[0];
// };


//   const formatNoteDate = (dateStr) => {
//   if (!dateStr) return ''
//   // Convert "09.25.2025 13:07" → "09/25/2025 13:07"
//   const normalized = dateStr.replace(/\./g, '/')
//   const date = new Date(normalized)
//   return isNaN(date) ? dateStr : date.toLocaleDateString('en-US')
// }

// // ✅ Map all possible statuses to badge colors
// const getNoteStatusColor = (status) => {
//   switch (status?.toLowerCase()) {
//     case 'submitted': return 'success'
//     case 'completed': return 'success'
//     case 'pending':   return 'warning'
//     case 'draft':     return 'secondary'
//     default:          return 'info'
//   }
// }
// const latestNoteMap = React.useMemo(() => {
//   const map = {};

//   Object.keys(patientNotes || {}).forEach((id) => {
//     const notes = patientNotes[id];
//     if (!notes?.length) return;

//     map[id] = [...notes].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     )[0];
//   });

//   return map;
// }, [patientNotes]);




//   useEffect(() => {
//   getFacilities()
//   patientDataFn()
// }, [type])



//   return (
//     <div>
      



//   <CAccordion alwaysOpen>
//     {facilityData.map((item, index) => {
//       const filteredPatients = getPatientsByFacility(item.Name);

//       return (
//         <CAccordionItem
//           key={item.ID || index}
//           itemKey={index}
//           onClick={() => fetchNotesForFacility(item.Name, patientData)}
//           className="border-0 border-bottom my-2 mx-4"
        
          
//         >
//           <CAccordionHeader>
//             <div className="d-flex justify-content-between align-items-center w-100">
//               <span className="text-primary">
//                 {item.Name} ({filteredPatients.length})
//               </span>
//             </div>
//           </CAccordionHeader>

// <CAccordionBody className="p-0">
  
//   {filteredPatients.length > 0 ? (
//     filteredPatients.map((patient) => {
//       // const latestNote = getLatestNote(patient.PatientID);
//       const latestNote = latestNoteMap[patient.PatientID];

//         const patientAppointments = getPatientAppointment(patient.PatientID)
//   const latestAppointment = patientAppointments?.[0]

//       return (
//    <div
//   key={patient.PatientID}
//   className="patient-row-list"
//   style={{
//     minHeight: "60px",
//     display: "flex",
//     alignItems: "center",
//     borderBottom: "1px solid #d9d9d9",
//     width: "100%",
//     position: "relative",
//     paddingLeft: "8px",
//   }}
// >

   


//   {/* LEFT COLOR STRIP */}
//   <div
//     style={{
//       position: "absolute",
//       left: 0,
//       top: 0,
//       bottom: 0,
//       width: "5px",
//       borderRadius: "0 6px 6px 0",
//       backgroundColor:
//         patient.Status === "NewPatient"
//           ? "green"
//           : patient.Status === "Follow Up"
//           ? "#EE6E0D"
//           : "#ccc",

//           justifyContent: "space-between"
//     }}
//   />

//   <CTableHeaderCell className="border-0 px-4">
//     <span className="patient-name-fixed">
//       {patient.FirstName} {patient.MiddleName} {patient.LastName}
//     </span>


//     <span className="room-pill" style={{minWidth: "200px"}}>Room No: {patient?.Room}</span>
    
 


//     <span className="notestatus-pill" style={{minWidth: "150px"}}>DOB: {patient?.DOB || "N/A"}</span>
//     {/* <span className="schedule-pill" style={{minWidth: "150px"}}>Age: {patient?.Age}</span> */}
//   </CTableHeaderCell>

// <CTableHeaderCell
//   className="border-0"
//   style={{
//   marginLeft: "auto",
//     marginRight: "10px"
//   }}
// >
//   <div
//     style={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "flex-end",
//       gap: "12px",
//       height: "100%",
//     }}
//   >
//     {/* <span className="text-muted sm" style={{minWidth: "200px"}}>
//      Scheduled Date:  {getLatestNote(patient.PatientID)?.date?.split(" ")[0] || ""}
//     </span> */}

// {latestNote?.date && (
//   <span className="text-muted sm" style={{ minWidth: "200px" }}>
//     Last Visited:{" "}
//     {latestNote?.date.split(" ")[0]}
//   </span>
// )}


// {/* note:- the start date is the scheduled date */}



// {latestAppointment?.data?.StartTime && (
//   <span className="text-muted sm" style={{ minWidth: "220px" }}>
//     Scheduled Date: {latestAppointment.data.StartTime.split(" ")[0]}
//   </span>
// )}
// {/* {latestAppointment?.data?.EndTime && (
//   <span className="text-muted sm" style={{ minWidth: "220px" }}>
//     End: {latestAppointment.data.EndTime}
//   </span>
// )} */}



//     <span className="room-pill" style={{minWidth: "200px"}}>
//      Note Status: {latestNote?.status || "No Note Available"}
//     </span>
//   </div>
// </CTableHeaderCell>

// </div>
//       );
//     })
//   ) : (
//     <div className="p-3 text-muted">
//       No patients found in this facility.
//     </div>
//   )}
// </CAccordionBody>
//         </CAccordionItem>
//       );
//     })}
//   </CAccordion>

  
//     </div>
//   )
// }

// export default Facility





// import React, { useEffect, useState, useMemo } from 'react'
// import {
//   CCard, CCardBody, CButton, CAccordion, CAccordionItem,
//   CAccordionHeader, CAccordionBody, CSpinner, CBadge,
//   CTableDataCell, CTableRow, CTableBody, CTableHeaderCell,
//   CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
//   CForm, CFormSelect, CFormInput, CRow, CCol
// } from '@coreui/react'
// import { CalendarDays, Filter } from 'lucide-react'

// import FacilityCRUD from '../../services/general/getFacilityData.api'
// import SavePatients from '../../../src/services/general/savePatientinformation.api'
// import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
// import { getAllAppointments } from '../../../src/components/shared/appointmentFilterData'

// const DEFAULT_FILTERS = {
//   facility: '',
//   patientStatus: '',
//   noteStatus: '',
//   appointmentStatus: '',
//   dob: '',
// }

// const Facility = ({ type }) => {
//   const [facilityData, setFacilityData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [patientData, setPatientData] = useState([])
//   const [patientNotes, setPatientNotes] = useState({})
//   const [openedFacilities, setOpenedFacilities] = useState(new Set())
//   const [appointments, setAppointments] = useState([])
//   const [viewPatientDetail, setViewPatientDetail] = useState(null)
//   const [showFilters, setShowFilters] = useState(false)
//   const [filters, setFilters] = useState(DEFAULT_FILTERS)
//   const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS)

//   const getPatientAppointment = (patientID) => {
//     return appointments?.filter(
//       (a) => a?.data?.PatientID === patientID
//     ) || []
//   }

//   useEffect(() => {
//     getAppointmentData()
//     getLatestNote()
//   }, [])

//   useEffect(() => {
//     console.log("📊 Current appointments state:", appointments);
//   }, [appointments]);

//   const getFacilities = async () => {
//     setLoading(true)
//     try {
//       const res = await FacilityCRUD('SELECT', {})
//       const parsed = JSON.parse(res.d)
//       let data = parsed?.Data || []

//       data = data.sort((a, b) =>
//         (a.Name || "").localeCompare(b.Name || "")
//       );

//       if (type) {
//         data = data.filter((item) => item.Type === type)
//       }
//       setFacilityData(data)
//     } catch (err) {
//       console.error(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const getAppointmentData = async () => {
//     try {
//       const structureData = await getAllAppointments('GET');
//       const flatAppointments = structureData.flatMap(
//         (p) => p?.appointmentDetails || []
//       );
//       console.log("📦 FLAT APPOINTMENTS:", flatAppointments);
//       setAppointments(flatAppointments);
//     } catch (error) {
//       console.log("❌ Error in getAppointmentData", error);
//     }
//   };

//   const patientDataFn = async () => {
//     try {
//       const res = await SavePatients('GetAll', '', '', '')
//       const parsed = JSON.parse(res.d)
//       setPatientData(parsed?.Data || [])
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   const getPatientsByFacility = (facilityName) => {
//     if (!facilityName) return []
//     return patientData.filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )
//   }

//   const fetchNotesForFacility = async (facilityName, currentPatientData) => {
//     if (openedFacilities.has(facilityName)) return
//     setOpenedFacilities((prev) => new Set([...prev, facilityName]))

//     const patients = (currentPatientData || []).filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )

//     console.log('patients to fetch notes for:', patients.length, patients)

//     if (patients.length === 0) return

//     const notePromises = patients.map(async (patient) => {
//       try {
//         let data = await PatientNoteDataCRUD('GET', patient.PatientID)
//         console.log('raw note response for', patient.PatientID, data)

//         data = JSON.parse(data.d)?.Data || []
//         console.log('parsed notes for', patient.PatientID, data)
        
//         data.forEach(note => {
//           console.log(
//             'patient:',
//             patient.PatientID,
//             'noteId:',
//             note.id,
//             'status:',
//             note.status
//           );
//         });

//         data = data.map((item) => ({
//           ...item,
//           data: item?.data ? JSON.parse(item?.data) : {},
//         }))

//         return { patientID: patient.PatientID, notes: data }
//       } catch (err) {
//         console.error('Note fetch error for patient', patient.PatientID, err)
//         return { patientID: patient.PatientID, notes: [] }
//       }
//     })

//     const results = await Promise.all(notePromises)
//     console.log('all note results:', results)

//     setPatientNotes((prev) => {
//       const updated = { ...prev }
//       results.forEach(({ patientID, notes }) => {
//         updated[patientID] = notes
//       })
//       return updated
//     })
//   }

//   const getLatestNote = (patientID) => {
//     const notes = patientNotes?.[String(patientID)];
//     if (!Array.isArray(notes) || notes.length === 0) {
//       return null;
//     }
//     return [...notes].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     )[0];
//   };

//   const formatNoteDate = (dateStr) => {
//     if (!dateStr) return ''
//     const normalized = dateStr.replace(/\./g, '/')
//     const date = new Date(normalized)
//     return isNaN(date) ? dateStr : date.toLocaleDateString('en-US')
//   }

//   const getNoteStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'submitted': return 'success'
//       case 'completed': return 'success'
//       case 'pending': return 'warning'
//       case 'draft': return 'secondary'
//       default: return 'info'
//     }
//   }

//   const latestNoteMap = React.useMemo(() => {
//     const map = {};
//     Object.keys(patientNotes || {}).forEach((id) => {
//       const notes = patientNotes[id];
//       if (!notes?.length) return;
//       map[id] = [...notes].sort(
//         (a, b) => new Date(b.date) - new Date(a.date)
//       )[0];
//     });
//     return map;
//   }, [patientNotes]);

//   // Filter patients based on applied filters
//   const filterPatients = (patients) => {
//     return patients.filter(patient => {
//       // Filter by Patient Status
//       if (appliedFilters.patientStatus && patient.Status !== appliedFilters.patientStatus) {
//         return false
//       }

//       // Filter by Note Status
//       if (appliedFilters.noteStatus) {
//         const latestNote = latestNoteMap[patient.PatientID]
//         if (!latestNote || latestNote.status !== appliedFilters.noteStatus) {
//           return false
//         }
//       }

//       // Filter by Appointment Status
//       if (appliedFilters.appointmentStatus) {
//         const patientAppointments = getPatientAppointment(patient.PatientID)
//         const hasMatchingAppointment = patientAppointments.some(
//           apt => apt?.data?.Status === appliedFilters.appointmentStatus
//         )
//         if (!hasMatchingAppointment) {
//           return false
//         }
//       }
// // Filter by DOB (exact date match)
// if (appliedFilters.dob && patient.DOB) {
//   const patientDob = new Date(patient.DOB).toDateString()
//   const filterDob = new Date(appliedFilters.dob).toDateString()

//   if (patientDob !== filterDob) return false
// }
     

//       return true
//     })
//   }

//   // Apply filters
//   const handleApplyFilters = () => {
//     setAppliedFilters(filters)
//     setShowFilters(false)
//   }

//   // Reset all filters
//   const handleResetFilters = () => {
//     const resetFilters = DEFAULT_FILTERS
//     setFilters(resetFilters)
//     setAppliedFilters(resetFilters)
//     setShowFilters(false)
//   }

//   // Get unique values for filter dropdowns
//   const uniquePatientStatuses = useMemo(() => {
//     const statuses = new Set(patientData.map(p => p.Status).filter(Boolean))
//     return Array.from(statuses)
//   }, [patientData])

//   const uniqueNoteStatuses = useMemo(() => {
//     const statuses = new Set()
//     Object.values(patientNotes).forEach(notes => {
//       if (notes && notes.length > 0) {
//         notes.forEach(note => {
//           if (note.status) statuses.add(note.status)
//         })
//       }
//     })
//     return Array.from(statuses)
//   }, [patientNotes])

//   const uniqueAppointmentStatuses = useMemo(() => {
//     const statuses = new Set(appointments.map(apt => apt?.data?.Status).filter(Boolean))
//     return Array.from(statuses)
//   }, [appointments])

//   useEffect(() => {
//     getFacilities()
//     patientDataFn()
//   }, [type])

//   return (
//     <div>
//       {/* Filter Button */}
//       <div className="d-flex justify-content-end mb-3 mx-4">
//         <CButton 
//           color="primary" 
//           onClick={() => setShowFilters(true)}
//           className="d-flex align-items-center gap-2"
//         >
//           <Filter size={16} />
//           Filters
        
//         </CButton>
//       </div>

//       {/* Filter Modal */}
      
//       <CModal visible={showFilters} onClose={() => setShowFilters(false)} size="lg">
//         <CModalHeader>
//           <CModalTitle>Filter Patients</CModalTitle>
//         </CModalHeader>
//         <CModalBody>
//           <CForm>
//             <CRow className="mb-3">
//               <CCol md="6">
//                 <label className="form-label">Patient Status</label>
//                 <CFormSelect
//                   value={filters.patientStatus}
//                   onChange={(e) => setFilters({...filters, patientStatus: e.target.value})}
//                 >
//                   <option value="">All</option>
//                   {uniquePatientStatuses.map(status => (
//                     <option key={status} value={status}>{status}</option>
//                   ))}
//                 </CFormSelect>
//               </CCol>
              
//               <CCol md="6">
//                 <label className="form-label">Note Status</label>
//                 <CFormSelect
//                   value={filters.noteStatus}
//                   onChange={(e) => setFilters({...filters, noteStatus: e.target.value})}
//                 >
//                   <option value="">All</option>
//                   {uniqueNoteStatuses.map(status => (
//                     <option key={status} value={status}>{status}</option>
//                   ))}
//                 </CFormSelect>
//               </CCol>
//             </CRow>

//             <CRow className="mb-3">
//               <CCol md="6">
//                 <label className="form-label">Appointment Status</label>
//                 <CFormSelect
//                   value={filters.appointmentStatus}
//                   onChange={(e) => setFilters({...filters, appointmentStatus: e.target.value})}
//                 >
//                   <option value="">All</option>
//                   {uniqueAppointmentStatuses.map(status => (
//                     <option key={status} value={status}>{status}</option>
//                   ))}
//                 </CFormSelect>
//               </CCol>
              
//               <CCol md="6">
//                 <label className="form-label">Facility</label>
//                 <CFormSelect
//                   value={filters.facility}
//                   onChange={(e) => setFilters({...filters, facility: e.target.value})}
//                 >
//                   <option value="">All Facilities</option>
//                   {facilityData.map(facility => (
//                     <option key={facility.ID} value={facility.Name}>{facility.Name}</option>
//                   ))}
//                 </CFormSelect>
//               </CCol>
//             </CRow>

//             <CRow className="mb-3">
//            <CCol md="6">
//   <label className="form-label">DOB</label>
//   <CFormInput
//     type="date"
//     value={filters.dob}
//     onChange={(e) => setFilters({...filters, dob: e.target.value})}
//   />
// </CCol>
//             </CRow>
//           </CForm>
//         </CModalBody>
//         <CModalFooter>
//           <CButton color="primary" variant='outline'  onClick={handleResetFilters}>
//             Reset All
//           </CButton>
//           <CButton color="primary" onClick={handleApplyFilters}>
//             Apply Filters
//           </CButton>
//         </CModalFooter>
//       </CModal>

//       {/* Active Filters Display */}
//       {Object.values(appliedFilters).some(v => v) && (
//         <div className="mx-4 mb-3 d-flex gap-2 flex-wrap">
//           {appliedFilters.patientStatus && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Patient: {appliedFilters.patientStatus}
//               <CButton 
//                 size="sm" 
//                 variant="ghost" 
//                 className="p-0 ms-1" 
//                 onClick={() => {
//                   setFilters({...filters, patientStatus: ''})
//                   setAppliedFilters({...appliedFilters, patientStatus: ''})
//                 }}
//               >
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.noteStatus && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Note: {appliedFilters.noteStatus}
//               <CButton 
//                 size="sm" 
//                 variant="ghost" 
//                 className="p-0 ms-1" 
//                 onClick={() => {
//                   setFilters({...filters, noteStatus: ''})
//                   setAppliedFilters({...appliedFilters, noteStatus: ''})
//                 }}
//               >
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.appointmentStatus && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Appointment: {appliedFilters.appointmentStatus}
//               <CButton 
//                 size="sm" 
//                 variant="ghost" 
//                 className="p-0 ms-1" 
//                 onClick={() => {
//                   setFilters({...filters, appointmentStatus: ''})
//                   setAppliedFilters({...appliedFilters, appointmentStatus: ''})
//                 }}
//               >
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.facility && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Facility: {appliedFilters.facility}
//               <CButton 
//                 size="sm" 
//                 variant="ghost" 
//                 className="p-0 ms-1" 
//                 onClick={() => {
//                   setFilters({...filters, facility: ''})
//                   setAppliedFilters({...appliedFilters, facility: ''})
//                 }}
//               >
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {(appliedFilters.dob) && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               DOB: 
//               <CButton 
//                 size="sm" 
//                 variant="ghost" 
//                 className="p-0 ms-1" 
            
//               >
//                  {appliedFilters.dob}
//               </CButton>
//             </CBadge>
//           )}
//         </div>
//       )}

//       <CAccordion alwaysOpen>
//         {facilityData
//           .filter(facility => {
//             // Filter facilities based on facility filter
//             if (appliedFilters.facility && facility.Name !== appliedFilters.facility) {
//               return false
//             }
//             return true
//           })
//           .map((item, index) => {
//             let filteredPatients = getPatientsByFacility(item.Name);
            
//             // Apply all filters to patients
//             filteredPatients = filterPatients(filteredPatients);

//             return (
//               <CAccordionItem
//                 key={item.ID || index}
//                 itemKey={index}
//                 onClick={() => fetchNotesForFacility(item.Name, patientData)}
//                 className="border-0 border-bottom my-2 mx-4"
//               >
//                 <CAccordionHeader>
//                   <div className="d-flex justify-content-between align-items-center w-100">
//                     <span className="text-primary">
//                       {item.Name} ({filteredPatients.length})
//                     </span>
//                   </div>
//                 </CAccordionHeader>

//                 <CAccordionBody className="p-0">
//                   {filteredPatients.length > 0 ? (
//                     filteredPatients.map((patient) => {
//                       const latestNote = latestNoteMap[patient.PatientID];
//                       const patientAppointments = getPatientAppointment(patient.PatientID)
//                       const latestAppointment = patientAppointments?.[0]

//                       return (
//                         <div
//                           key={patient.PatientID}
//                           className="patient-row-list"
//                           style={{
//                             minHeight: "60px",
//                             display: "flex",
//                             alignItems: "center",
//                             borderBottom: "1px solid #d9d9d9",
//                             width: "100%",
//                             position: "relative",
//                             paddingLeft: "8px",
//                           }}
//                         >
//                           {/* LEFT COLOR STRIP */}
//                           <div
//                             style={{
//                               position: "absolute",
//                               left: 0,
//                               top: 0,
//                               bottom: 0,
//                               width: "5px",
//                               borderRadius: "0 6px 6px 0",
//                               backgroundColor:
//                                 patient.Status === "NewPatient"
//                                   ? "green"
//                                   : patient.Status === "Follow Up"
//                                   ? "#EE6E0D"
//                                   : "#ccc",
//                               justifyContent: "space-between"
//                             }}
//                           />

//                           <CTableHeaderCell className="border-0 px-4">
//                             <span className="patient-name-fixed">
//                               {patient.FirstName} {patient.MiddleName} {patient.LastName}
//                             </span>

//                             <span className="room-pill" style={{ minWidth: "200px" }}>Room No: {patient?.Room}</span>

//                             <span className="notestatus-pill" style={{ minWidth: "150px" }}>DOB: {patient?.DOB || "N/A"}</span>
//                           </CTableHeaderCell>

//                           <CTableHeaderCell
//                             className="border-0"
//                             style={{
//                               marginLeft: "auto",
//                               marginRight: "10px"
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "flex-end",
//                                 gap: "12px",
//                                 height: "100%",
//                               }}
//                             >
//                               {latestNote?.date && (
//                                 <span className="text-muted sm" style={{ minWidth: "200px" }}>
//                                   Last Visited:{" "}
//                                   {latestNote?.date.split(" ")[0]}
//                                 </span>
//                               )}

//                               {latestAppointment?.data?.StartTime && (
//                                 <span className="text-muted sm" style={{ minWidth: "220px" }}>
//                                   Scheduled Date: {latestAppointment.data.StartTime.split(" ")[0]}
//                                 </span>
//                               )}

//                               <span className="room-pill" style={{ minWidth: "200px" }}>
//                                 Note Status: {latestNote?.status || "No Note Available"}
//                               </span>
//                             </div>
//                           </CTableHeaderCell>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="p-3 text-muted">
//                       No patients found matching the filters.
//                     </div>
//                   )}
//                 </CAccordionBody>
//               </CAccordionItem>
//             );
//           })}
//       </CAccordion>
//     </div>
//   )
// }

// export default Facility






// import React, { useEffect, useState, useMemo, useRef } from 'react'
// import {
//   CCard, CCardBody, CButton, CAccordion, CAccordionItem,
//   CAccordionHeader, CAccordionBody, CSpinner, CBadge,
//   CTableDataCell, CTableRow, CTableBody, CTableHeaderCell,
//   CForm, CFormSelect, CFormInput, CRow, CCol, CFormLabel
// } from '@coreui/react'
// import { CalendarDays, Filter, X } from 'lucide-react'
// import { motion, AnimatePresence } from 'framer-motion'

// import FacilityCRUD from '../../services/general/getFacilityData.api'
// import SavePatients from '../../../src/services/general/savePatientinformation.api'
// import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
// import { getAllAppointments } from '../../../src/components/shared/appointmentFilterData'

// const DEFAULT_FILTERS = {
//   facility: '',
//   patientStatus: '',
//   noteStatus: '',
//   appointmentStatus: '',
//   dob: '',
// }

// const Facility = ({ type }) => {
//   const [facilityData, setFacilityData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [patientData, setPatientData] = useState([])
//   const [patientNotes, setPatientNotes] = useState({})
//   const [openedFacilities, setOpenedFacilities] = useState(new Set())
//   const [appointments, setAppointments] = useState([])
//   const [viewPatientDetail, setViewPatientDetail] = useState(null)
//   const [showFilters, setShowFilters] = useState(false)
//   const [filters, setFilters] = useState(DEFAULT_FILTERS)
//   const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS)

//   // Ref to handle click-outside to close the dropdown
//   const filterRef = useRef(null)

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (filterRef.current && !filterRef.current.contains(e.target)) {
//         setShowFilters(false)
//       }
//     }
//     if (showFilters) {
//       document.addEventListener('mousedown', handleClickOutside)
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside)
//   }, [showFilters])

//   const getPatientAppointment = (patientID) => {
//     return appointments?.filter(
//       (a) => a?.data?.PatientID === patientID
//     ) || []
//   }

//   useEffect(() => {
//     getAppointmentData()
//     getLatestNote()
//   }, [])

//   useEffect(() => {
//     console.log("📊 Current appointments state:", appointments);
//   }, [appointments]);

//   const getFacilities = async () => {
//     setLoading(true)
//     try {
//       const res = await FacilityCRUD('SELECT', {})
//       const parsed = JSON.parse(res.d)
//       let data = parsed?.Data || []

//       data = data.sort((a, b) =>
//         (a.Name || "").localeCompare(b.Name || "")
//       );

//       if (type) {
//         data = data.filter((item) => item.Type === type)
//       }
//       setFacilityData(data)
//     } catch (err) {
//       console.error(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const getAppointmentData = async () => {
//     try {
//       const structureData = await getAllAppointments('GET');
//       const flatAppointments = structureData.flatMap(
//         (p) => p?.appointmentDetails || []
//       );
//       console.log("📦 FLAT APPOINTMENTS:", flatAppointments);
//       setAppointments(flatAppointments);
//     } catch (error) {
//       console.log("❌ Error in getAppointmentData", error);
//     }
//   };

//   const patientDataFn = async () => {
//     try {
//       const res = await SavePatients('GetAll', '', '', '')
//       const parsed = JSON.parse(res.d)
//       setPatientData(parsed?.Data || [])
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   const getPatientsByFacility = (facilityName) => {
//     if (!facilityName) return []
//     return patientData.filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )
//   }

//   const fetchNotesForFacility = async (facilityName, currentPatientData) => {
//     if (openedFacilities.has(facilityName)) return
//     setOpenedFacilities((prev) => new Set([...prev, facilityName]))

//     const patients = (currentPatientData || []).filter(
//       (p) =>
//         (p.FacilityName || '').trim().toLowerCase() ===
//         facilityName.trim().toLowerCase()
//     )

//     if (patients.length === 0) return

//     const notePromises = patients.map(async (patient) => {
//       try {
//         let data = await PatientNoteDataCRUD('GET', patient.PatientID)
//         data = JSON.parse(data.d)?.Data || []

//         data = data.map((item) => ({
//           ...item,
//           data: item?.data ? JSON.parse(item?.data) : {},
//         }))

//         return { patientID: patient.PatientID, notes: data }
//       } catch (err) {
//         console.error('Note fetch error for patient', patient.PatientID, err)
//         return { patientID: patient.PatientID, notes: [] }
//       }
//     })

//     const results = await Promise.all(notePromises)

//     setPatientNotes((prev) => {
//       const updated = { ...prev }
//       results.forEach(({ patientID, notes }) => {
//         updated[patientID] = notes
//       })
//       return updated
//     })
//   }

//   const getLatestNote = (patientID) => {
//     const notes = patientNotes?.[String(patientID)];
//     if (!Array.isArray(notes) || notes.length === 0) return null;
//     return [...notes].sort(
//       (a, b) => new Date(b.date) - new Date(a.date)
//     )[0];
//   };

//   const formatNoteDate = (dateStr) => {
//     if (!dateStr) return ''
//     const normalized = dateStr.replace(/\./g, '/')
//     const date = new Date(normalized)
//     return isNaN(date) ? dateStr : date.toLocaleDateString('en-US')
//   }

//   const getNoteStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'submitted': return 'success'
//       case 'completed': return 'success'
//       case 'pending': return 'warning'
//       case 'draft': return 'secondary'
//       default: return 'info'
//     }
//   }

//   const latestNoteMap = React.useMemo(() => {
//     const map = {};
//     Object.keys(patientNotes || {}).forEach((id) => {
//       const notes = patientNotes[id];
//       if (!notes?.length) return;
//       map[id] = [...notes].sort(
//         (a, b) => new Date(b.date) - new Date(a.date)
//       )[0];
//     });
//     return map;
//   }, [patientNotes]);

//   const filterPatients = (patients) => {
//     return patients.filter(patient => {
//       if (appliedFilters.patientStatus && patient.Status !== appliedFilters.patientStatus) return false

//       if (appliedFilters.noteStatus) {
//         const latestNote = latestNoteMap[patient.PatientID]
//         if (!latestNote || latestNote.status !== appliedFilters.noteStatus) return false
//       }

//       if (appliedFilters.appointmentStatus) {
//         const patientAppointments = getPatientAppointment(patient.PatientID)
//         const hasMatchingAppointment = patientAppointments.some(
//           apt => apt?.data?.Status === appliedFilters.appointmentStatus
//         )
//         if (!hasMatchingAppointment) return false
//       }

//       if (appliedFilters.dob && patient.DOB) {
//         const patientDob = new Date(patient.DOB).toDateString()
//         const filterDob = new Date(appliedFilters.dob).toDateString()
//         if (patientDob !== filterDob) return false
//       }

//       return true
//     })
//   }

//   const handleApplyFilters = () => {
//     setAppliedFilters(filters)
//     setShowFilters(false)
//   }

//   const handleResetFilters = () => {
//     const resetFilters = DEFAULT_FILTERS
//     setFilters(resetFilters)
//     setAppliedFilters(resetFilters)
//     setShowFilters(false)
//   }

//   const uniquePatientStatuses = useMemo(() => {
//     const statuses = new Set(patientData.map(p => p.Status).filter(Boolean))
//     return Array.from(statuses)
//   }, [patientData])

//   // const uniqueNoteStatuses = useMemo(() => {
//   //   const statuses = new Set()
//   //   Object.values(patientNotes).forEach(notes => {
//   //     if (notes?.length) notes.forEach(note => { if (note.status) statuses.add(note.status) })
//   //   })
//   //   return Array.from(statuses)
//   // }, [patientNotes])


//   const uniqueNoteStatuses = ['Draft', 'Submitted', 'Pending', 'Completed']




//   const uniqueAppointmentStatuses = useMemo(() => {
//     const statuses = new Set(appointments.map(apt => apt?.data?.Status).filter(Boolean))
//     return Array.from(statuses)
//   }, [appointments])

//   const activeFilterCount = Object.values(appliedFilters).filter(Boolean).length

//   useEffect(() => {
//     getFacilities()
//     patientDataFn()
//   }, [type])

//   return (
//     <div>

//       {/* ─── Filter Button + Popover ─── */}
//       <div className="d-flex justify-content-end mb-3 mx-4">
//         <div className="position-relative" ref={filterRef}>

//           {/* Trigger Button */}
//           <button
//             onClick={() => setShowFilters((prev) => !prev)}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px',
//               padding: '8px 16px',
//               border: '1px solid #d0d5dd',
//               borderRadius: '8px',
//               background: showFilters ? '#f0f5ff' : '#fff',
//               cursor: 'pointer',
//               fontSize: '14px',
//               fontWeight: 500,
//               color: '#344054',
//               boxShadow: '0 1px 2px rgba(16,24,40,0.05)',
//               position: 'relative',
//             }}
//           >
//             <Filter size={15} />
//             Filter
//             {activeFilterCount > 0 && (
//               <span style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: '18px',
//                 height: '18px',
//                 borderRadius: '50%',
//                 background: '#3b82f6',
//                 color: '#fff',
//                 fontSize: '11px',
//                 fontWeight: 700,
//                 marginLeft: '2px',
//               }}>
//                 {activeFilterCount}
//               </span>
//             )}
//           </button>

//           {/* Animated Dropdown Panel */}
//           <AnimatePresence>
//             {showFilters && (
//               <motion.div
//                 initial={{ opacity: 0, y: 6, scale: 0.98 }}
//                 animate={{ opacity: 1, y: 0, scale: 1 }}
//                 exit={{ opacity: 0, y: 6, scale: 0.98 }}
//                 transition={{ duration: 0.18, ease: 'easeOut' }}
//                 style={{
//                   position: 'absolute',
//                   top: 'calc(100% + 8px)',
//                   right: 0,
//                   width: '320px',
//                   zIndex: 1050,
//                   background: '#fff',
//                   borderRadius: '12px',
//                   boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
//                   border: '1px solid #e4e7ec',
//                   padding: '16px',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   gap: '12px',
//                 }}
//               >
//                 {/* Header */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
//                   <span style={{ fontWeight: 600, fontSize: '14px', color: '#101828' }}>Filters</span>
//                   {activeFilterCount > 0 && (
//                     <button
//                       onClick={handleResetFilters}
//                       style={{
//                         background: 'none', border: 'none', cursor: 'pointer',
//                         fontSize: '12px', color: '#6941c6', fontWeight: 500, padding: 0,
//                       }}
//                     >
//                       Reset all
//                     </button>
//                   )}
//                 </div>

//                 {/* Patient Status */}
//                 <div>
//                   <CFormLabel style={{ fontSize: '12px', fontWeight: 500, color: '#344054', marginBottom: '4px' }}>
//                     Patient Status
//                   </CFormLabel>
//                   <CFormSelect
//                     value={filters.patientStatus}
//                     onChange={(e) => setFilters({ ...filters, patientStatus: e.target.value })}
//                     style={{ fontSize: '13px' }}
//                   >
//                     <option value="">All</option>
//                     {uniquePatientStatuses.map(status => (
//                       <option key={status} value={status}>{status}</option>
//                     ))}
//                   </CFormSelect>
//                 </div>

//                 {/* Note Status */}
//                 <div>
//                   <CFormLabel style={{ fontSize: '12px', fontWeight: 500, color: '#344054', marginBottom: '4px' }}>
//                     Note Status
//                   </CFormLabel>
//                   <CFormSelect
//                     value={filters.noteStatus}
//                     onChange={(e) => setFilters({ ...filters, noteStatus: e.target.value })}
//                     style={{ fontSize: '13px' }}
//                   >
//                     <option value="">All</option>
//                     {uniqueNoteStatuses.map(status => (
//                       <option key={status} value={status}>{status}</option>
//                     ))}
//                   </CFormSelect>
//                 </div>

//                 {/* Appointment Status */}
//                 <div>
//                   <CFormLabel style={{ fontSize: '12px', fontWeight: 500, color: '#344054', marginBottom: '4px' }}>
//                     Appointment Status
//                   </CFormLabel>
//                   <CFormSelect
//                     value={filters.appointmentStatus}
//                     onChange={(e) => setFilters({ ...filters, appointmentStatus: e.target.value })}
//                     style={{ fontSize: '13px' }}
//                   >
//                     <option value="">All</option>
//                     {uniqueAppointmentStatuses.map(status => (
//                       <option key={status} value={status}>{status}</option>
//                     ))}
//                   </CFormSelect>
//                 </div>

//                 {/* Facility */}
//                 <div>
//                   <CFormLabel style={{ fontSize: '12px', fontWeight: 500, color: '#344054', marginBottom: '4px' }}>
//                     Facility
//                   </CFormLabel>
//                   <CFormSelect
//                     value={filters.facility}
//                     onChange={(e) => setFilters({ ...filters, facility: e.target.value })}
//                     style={{ fontSize: '13px' }}
//                   >
//                     <option value="">All Facilities</option>
//                     {facilityData.map(facility => (
//                       <option key={facility.ID} value={facility.Name}>{facility.Name}</option>
//                     ))}
//                   </CFormSelect>
//                 </div>

//                 {/* DOB */}
//                 <div style={{ position: 'relative' }}>
//                   <CFormLabel style={{ fontSize: '12px', fontWeight: 500, color: '#344054', marginBottom: '4px' }}>
//                     Date of Birth
//                   </CFormLabel>
//                   <div style={{ position: 'relative' }}>
//                     <CFormInput
//                       type="date"
//                       value={filters.dob}
//                       onChange={(e) => setFilters({ ...filters, dob: e.target.value })}
//                       style={{ fontSize: '13px', paddingRight: filters.dob ? '32px' : undefined }}
//                     />
//                     {filters.dob && (
//                       <button
//                         onClick={() => setFilters({ ...filters, dob: '' })}
//                         style={{
//                           position: 'absolute',
//                           right: '8px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: '#98a2b3',
//                           border: 'none',
//                           cursor: 'pointer',
//                           borderRadius: '50%',
//                           width: '18px',
//                           height: '18px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           color: '#fff',
//                           padding: 0,
//                           zIndex: 2,
//                         }}
//                       >
//                         <X size={11} strokeWidth={3} />
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 {/* Footer Actions */}
//                 <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
//                   <button
//                     onClick={() => setShowFilters(false)}
//                     style={{
//                       flex: 1,
//                       padding: '8px',
//                       border: '1px solid #d0d5dd',
//                       borderRadius: '8px',
//                       background: '#fff',
//                       cursor: 'pointer',
//                       fontSize: '13px',
//                       fontWeight: 500,
//                       color: '#344054',
//                     }}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleApplyFilters}
//                     style={{
//                       flex: 1,
//                       padding: '8px',
//                       border: 'none',
//                       borderRadius: '8px',
//                       background: '#3b82f6',
//                       cursor: 'pointer',
//                       fontSize: '13px',
//                       fontWeight: 500,
//                       color: '#fff',
//                     }}
//                   >
//                     Apply Filters
//                   </button>
//                 </div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </div>
//       </div>

//       {/* ─── Active Filter Badges ─── */}
//       {Object.values(appliedFilters).some(v => v) && (
//         <div className="mx-4 mb-3 d-flex gap-2 flex-wrap">
//           {appliedFilters.patientStatus && (
//             <CBadge color="info"  className="d-flex align-items-center gap-1 ">
//               Patient: {appliedFilters.patientStatus}
//               <CButton size="sm" variant="ghost" className="p-0 ms-1"
//                 onClick={() => { setFilters({ ...filters, patientStatus: '' }); setAppliedFilters({ ...appliedFilters, patientStatus: '' }) }}>
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.noteStatus && (

//               <CBadge
//   color="primary"
//   shape="rounded-pill"
//   className="d-flex align-items-center gap-1 px-2 py-1 border border-primary text-primary bg-transparent"
// >

//               Note: {appliedFilters.noteStatus}
//               <CButton size="sm" variant="ghost" className="p-0 ms-1"
//                 onClick={() => { setFilters({ ...filters, noteStatus: '' }); setAppliedFilters({ ...appliedFilters, noteStatus: '' }) }}>
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.appointmentStatus && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Appointment: {appliedFilters.appointmentStatus}
//               <CButton size="sm" variant="ghost" className="p-0 ms-1"
//                 onClick={() => { setFilters({ ...filters, appointmentStatus: '' }); setAppliedFilters({ ...appliedFilters, appointmentStatus: '' }) }}>
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.facility && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               Facility: {appliedFilters.facility}
//               <CButton size="sm" variant="ghost" className="p-0 ms-1"
//                 onClick={() => { setFilters({ ...filters, facility: '' }); setAppliedFilters({ ...appliedFilters, facility: '' }) }}>
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//           {appliedFilters.dob && (
//             <CBadge color="info" className="d-flex align-items-center gap-1">
//               DOB: {appliedFilters.dob}
//               <CButton size="sm" variant="ghost" className="p-0 ms-1"
//                 onClick={() => { setFilters({ ...filters, dob: '' }); setAppliedFilters({ ...appliedFilters, dob: '' }) }}>
//                 ✕
//               </CButton>
//             </CBadge>
//           )}
//         </div>
//       )}

//       {/* ─── Accordion List ─── */}
//       <CAccordion alwaysOpen>
//         {facilityData
//           .filter(facility => {
//             if (appliedFilters.facility && facility.Name !== appliedFilters.facility) return false
//             return true
//           })
//           .map((item, index) => {
//             let filteredPatients = getPatientsByFacility(item.Name);
//             filteredPatients = filterPatients(filteredPatients);

//             return (
//               <CAccordionItem
//                 key={item.ID || index}
//                 itemKey={index}
//                 onClick={() => fetchNotesForFacility(item.Name, patientData)}
//                 className="border-0 border-bottom my-2 mx-4"
//               >
//                 <CAccordionHeader>
//                   <div className="d-flex justify-content-between align-items-center w-100">
//                     <span className="text-primary">
//                       {item.Name} ({filteredPatients.length})
//                     </span>
//                   </div>
//                 </CAccordionHeader>

//                 <CAccordionBody className="p-0">
//                   {filteredPatients.length > 0 ? (
//                     filteredPatients.map((patient) => {
//                       const latestNote = latestNoteMap[patient.PatientID];
//                       const patientAppointments = getPatientAppointment(patient.PatientID)
//                       const latestAppointment = patientAppointments?.[0]

//                       return (
//                         <div
//                           key={patient.PatientID}
//                           className="patient-row-list"
//                           style={{
//                             minHeight: "60px",
//                             display: "flex",
//                             alignItems: "center",
//                             borderBottom: "1px solid #d9d9d9",
//                             width: "100%",
//                             position: "relative",
//                             paddingLeft: "8px",
//                           }}
//                         >
//                           <div
//                             style={{
//                               position: "absolute",
//                               left: 0,
//                               top: 0,
//                               bottom: 0,
//                               width: "5px",
//                               borderRadius: "0 6px 6px 0",
//                               backgroundColor:
//                                 patient.Status === "NewPatient" ? "green"
//                                   : patient.Status === "Follow Up" ? "#EE6E0D"
//                                     : "#ccc",
//                               justifyContent: "space-between"
//                             }}
//                           />

//                           <CTableHeaderCell className="border-0 px-4">
//                             <span className="patient-name-fixed">
//                               {patient.FirstName} {patient.MiddleName} {patient.LastName}
//                             </span>
//                             <span className="room-pill" style={{ minWidth: "200px" }}>Room No: {patient?.Room}</span>
//                             <span className="notestatus-pill" style={{ minWidth: "150px" }}>DOB: {patient?.DOB || "N/A"}</span>
//                           </CTableHeaderCell>

//                           <CTableHeaderCell
//                             className="border-0"
//                             style={{ marginLeft: "auto", marginRight: "10px" }}
//                           >
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "12px", height: "100%" }}>
//                               {latestNote?.date && (
//                                 <span className="text-muted sm" style={{ minWidth: "200px" }}>
//                                   Last Visited: {latestNote?.date.split(" ")[0]}
//                                 </span>
//                               )}
//                               {latestAppointment?.data?.StartTime && (
//                                 <span className="text-muted sm" style={{ minWidth: "220px" }}>
//                                   Scheduled Date: {latestAppointment.data.StartTime.split(" ")[0]}
//                                 </span>
//                               )}
//                               <span className="room-pill" style={{ minWidth: "200px" }}>
//                                 Note Status: {latestNote?.status || "No Note Available"}
//                               </span>
//                             </div>
//                           </CTableHeaderCell>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="p-3 text-muted">
//                       No patients found matching the filters.
//                     </div>
//                   )}
//                 </CAccordionBody>
//               </CAccordionItem>
//             );
//           })}
//       </CAccordion>
//     </div>
//   )
// }

// export default Facility
